import _React, { useContext } from 'react';
import { TableContext } from '../tableContext';

export default () => {
  const tableContext = useContext(TableContext);
  return [tableContext];
};
